module.exports = __webpack_public_path__ + "media/img/pages/companies/vaudoise-43d8fe64390b4fe2108c33c38a3487da.png";